import React from 'react'
import { useHistory } from 'react-router-dom'
import MovieSearchLinkWithRouter from './MovieSearchLinkWithRouter'
import MovieSearchLinkWithoutRouter from './MovieSearchLinkWithoutRouter'

const MovieSearchLinkContainer =({
    searchLinkClass='',
    programOverviewUrl='',
    iconThin=true,
    isSearchToggle=false,
    translation
}) => {
    let history = useHistory()

    if(history)  {
        return <MovieSearchLinkWithRouter
            searchLinkClass={searchLinkClass}
            isSearchToggle={isSearchToggle}
            iconThin={iconThin}
            translation={translation}
        />
    } else if(programOverviewUrl) {
        return <MovieSearchLinkWithoutRouter 
            searchLinkClass={searchLinkClass}
            programOverviewUrl={programOverviewUrl}
            iconThin={iconThin}
            translation={translation}
        />
    } else {
        return ''
    }
}

export default MovieSearchLinkContainer 